/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface LanguageCultureInfoDto
 */
export interface LanguageCultureInfoDto {
    /**
     * 
     * @type {string}
     * @memberof LanguageCultureInfoDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageCultureInfoDto
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageCultureInfoDto
     */
    icon?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LanguageCultureInfoDto
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LanguageCultureInfoDto
     */
    $type?: LanguageCultureInfoDtoTypeEnum;
}


/**
 * @export
 */
export const LanguageCultureInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedLocalizationDtoLanguageCultureInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Localization.Dto.LanguageCultureInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type LanguageCultureInfoDtoTypeEnum = typeof LanguageCultureInfoDtoTypeEnum[keyof typeof LanguageCultureInfoDtoTypeEnum];


/**
 * Check if a given object implements the LanguageCultureInfoDto interface.
 */
export function instanceOfLanguageCultureInfoDto(value?: unknown): value is LanguageCultureInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(LanguageCultureInfoDtoTypeEnum)[0];
}

export function LanguageCultureInfoDtoFromJSON(json: any): LanguageCultureInfoDto {
    return LanguageCultureInfoDtoFromJSONTyped(json, false);
}

export function LanguageCultureInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageCultureInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'displayName': json['displayName'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'isDisabled': !exists(json, 'isDisabled') ? undefined : json['isDisabled'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function LanguageCultureInfoDtoToJSON(value?: LanguageCultureInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'displayName': value.displayName,
        'icon': value.icon,
        'isDisabled': value.isDisabled,
        '$type': value.$type,
    });
}

